var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPuzzlePiece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "#126973"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11C18.44 11 17.92 11.2 17.56 11.56C17.2 11.92 17 12.44 17 13C17 13.56 17.36 13.96 17.56 14.44C17.62 14.56 17.62 14.76 17.62 15H13V27H17.62C17.62 26.76 17.6 26.56 17.56 26.44C17.36 25.96 17 25.56 17 25C17 24.44 17.2 23.92 17.56 23.56C17.92 23.2 18.44 23 19 23C19.56 23 20.08 23.2 20.44 23.56C20.8 23.92 21 24.44 21 25C21 25.56 20.64 25.96 20.44 26.44C20.38 26.56 20.38 26.76 20.38 27H25V22.38C25.24 22.38 25.44 22.4 25.56 22.44C26.04 22.64 26.44 23 27 23C27.56 23 28.08 22.8 28.44 22.44C28.8 22.08 29 21.56 29 21C29 20.44 28.8 19.92 28.44 19.56C28.08 19.2 27.56 19 27 19C26.44 19 26.04 19.36 25.56 19.56C25.44 19.62 25.24 19.62 25 19.62V15H20.38C20.38 14.76 20.4 14.56 20.44 14.44C20.64 13.96 21 13.56 21 13C21 12.44 20.8 11.92 20.44 11.56C20.08 11.2 19.56 11 19 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPuzzlePiece);
export default __webpack_public_path__ + "static/media/icon-puzzle-piece.319e55dbf66b0d9e60ab8deabda65354.svg";
export { ForwardRef as ReactComponent };